import { render, staticRenderFns } from "./MetricsAverageResp.vue?vue&type=template&id=22371559"
import script from "./MetricsAverageResp.vue?vue&type=script&lang=js"
export * from "./MetricsAverageResp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports